<template>
  <pay-on-web-popup @close="emitCloseEvent">
    <template #icon>
      <img src="@/assets/pink-flower-drawing.svg" class="popup-icon" alt="" />
    </template>
    <template #title>
      <div class="popup-title">איך לשלם מחיר נמוך יותר על המינוי שלי?</div>
    </template>
    <template #subtitles>
      <div>Apple גובה עלויות נוספות על אפליקציות שנקנו דרך ה־App Store.</div>
      <div class="bold margin-top-m">
        ההמלצה שלנו היא לקנות מינוי דרך הדפדפן, ולחזור להשתמש באפליקציה אחרי הרכישה.
      </div>
    </template>
    <template #bullets>
      <li>
        להתחבר לרייזאפ דרך הדפדפן שלך (מבלי לעבור לאפליקציה).
      </li>
      <li>
        להיכנס לתפריט הראשי במוצר > הגדרות > הגדרות מינוי. ואז ללחוץ על כפתור "לבחור סוג מינוי".<br>
        <b>כאן אפשר לשלם פחות על המינוי.</b>
      </li>
      <li>
        סיימת! עכשיו<b>אפשר לחזור לאפליקציה</b> ולהמשיך להיות על זה איתנו.
      </li>
    </template>
  </pay-on-web-popup>
</template>

<script>
import Segment from '@/Segment';
import PayOnWebPopup from './PayOnWebPopup.vue';

export default {
  name: 'TrialPayOnWebPopup',
  components: {
    PayOnWebPopup,
  },
  methods: {
    emitCloseEvent() {
      this.$emit('close');
    },
  },
  created() {
    Segment.trackUserInteraction('ApplePricePopup_NoPromo_Viewed');
  },
};
</script>
